

    import Vue from "vue";
    import { Component, Prop } from 'vue-property-decorator'

    @Component
    export default  class SidebarLgComponent extends Vue {
        @Prop({ type: Boolean, default: false })
        showSidebar: boolean
    }
    
